import React from 'react';
import { motion } from 'framer-motion';

const team = [
  {
    name: 'Elena Rostova',
    role: 'Master Stylist & Founder',
    image: 'https://images.unsplash.com/photo-1595476108010-b4d1f10d5e43?auto=format&fit=crop&q=80&w=800'
  },
  {
    name: 'Marcus Chen',
    role: 'Color Specialist',
    image: 'https://images.unsplash.com/photo-1522337660859-02fbefca4702?auto=format&fit=crop&q=80&w=800'
  },
  {
    name: 'Sarah Jenkins',
    role: 'Extensions Expert',
    image: 'https://images.unsplash.com/photo-1605497788044-5a32c707d5d4?auto=format&fit=crop&q=80&w=800'
  }
];

export default function Stylists() {
  return (
    <section id="stylists" className="py-24 bg-brand-dark text-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16">
          <div>
            <h2 className="text-4xl md:text-5xl font-serif mb-4">Meet The Experts</h2>
            <div className="w-16 h-1 bg-brand-accent"></div>
          </div>
          <p className="text-gray-400 max-w-md mt-6 md:mt-0 font-light hidden md:block">
            Our team of passionate professionals are dedicated to bringing your vision to life with unparalleled expertise.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {team.map((stylist, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative overflow-hidden"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img 
                  src={stylist.image} 
                  alt={stylist.name} 
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-8">
                <h3 className="text-2xl font-serif mb-1">{stylist.name}</h3>
                <p className="text-brand-accent text-sm uppercase tracking-widest font-semibold">{stylist.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}